var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container690"},[_c('SelectAmount',{on:{"getAmountFunc":_vm.getAmount}}),_c('SubscribeForm',{on:{"getSubscribe":_vm.getSubscribe}}),_c('InformationForm',{ref:"inForm",on:{"getInform":_vm.getInform}}),_c('Pay',{on:{"donate":_vm.donate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }